<ycn-modal-base
    [extraModalClasses]="'public modal-no-border'"
    [open]="state.modalOpen"
    (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
        *ngIf="state.featureInfo"
        [header]="state.featureInfo.feature_headline"
        (closeModalHandler)="closeModal()"
        data-test-id="feature-needed-modal-header">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section" *ngIf="state.loading">
            <div class="loader">
                <div class="loader-message">Loading...</div>
                <div class="loader-spinner"></div>
            </div>
        </div>
        <div class="modal-section" *ngIf="state.featureInfo">
            <p class="public-intro">
                <span [textContent]="state.featureInfo.feature_description"></span>
                <span *ngIf="state.featureInfo.warn_about_addon">
                    <br><br>Please note that this feature is only available as an add-on to YCharts subscriptions.
                </span>
                <span *ngIf="state.featureInfo.warn_about_activate">
                    <br><br>Please note that this feature requires full activation of your account and is not permitted during the free trial period.
                </span>
            </p>
            <p class="form-inline">
                <a class="btn btn-lg btn-primary" target="_blank"
                    [href]="state.featureInfo.feature_payment_url"
                    [textContent]="state.featureInfo.call_to_action">
                </a>
                <span class="form-control-plaintext" *ngIf="!state.featureInfo.is_upgrade && !state.featureInfo.is_activate && !state.featureInfo.is_addon">
                    No credit card required.
                </span>
            </p>

            <div *ngIf="!state.featureInfo.is_upgrade && !state.featureInfo.is_activate && !state.featureInfo.is_addon">
                    Already a subscriber?
                    <a class="text-blue" [href]="state.featureInfo.login_url"><strong>Sign in.</strong></a>
            </div>
        </div>
        <div class="modal-section" *ngIf="state.error">
            <div class="modal-message">An error has occurred.</div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="modal-footer-actions"></div>
    </div>
</ycn-modal-base>
